// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2Zx8-","header":"ClearentDisclaimer_header__1kAxI","inner":"ClearentDisclaimer_inner__1c3xD"};